import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'ChequeRefusalReason';
const ENDPOINT = `/cheque-refusal-reasons/`;

@Injectable({
    providedIn: 'root'
})
export class ChequeRefusalReasonService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
